module.exports = __webpack_public_path__ + "static/upsell-2-f3393904604dd8b5481c518a2e72a4e2.png";